// 引入文件
import request from '../utils/request'

/**
 *  轮播图
 * @method get
 * @return {[type]}         [description]
 */
export function postGetShowBannerList(data) {
    return request({
        // url: 'http://192.168.111.253:8099/hatu/banner/getShowBannerList',
        url: 'https://crm.ihatoo.com:8099/banner/getShowBannerList',
        method: 'get',
        data
    })
}
